import { TraceType } from '../../../common/enums/TraceType';
import { Report } from './valueObjects/Report';

export class Slot {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly description: string,
    private readonly slotType: TraceType,
    private readonly latestReport: Report | null,
    private readonly reportCount: number,
    private readonly tags: string[]
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getSlotType() {
    return this.slotType;
  }

  getLatestReport() {
    return this.latestReport;
  }

  getReportCount() {
    return this.reportCount;
  }

  getTags() {
    return this.tags;
  }
}
